import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import QrCodeIcon from "@mui/icons-material/QrCode";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import {ReactComponent as ExcelIcon} from "../../../assets/images/excel.svg";
import {ReactComponent as WordIcon} from "../../../assets/images/word.svg";
import {ReactComponent as PdfIcon} from "../../../assets/images/pdf.svg";

export interface ActionButtonData {
  id: number;
  icon: React.ReactNode;
  caption: string;
  colors: ColorType;
  variant: VariantType;
  link?: string | number;
  anchor?: string;
  execution?: any;
  state?: number;
}

type ColorType =
  | "secondary"
  | "inherit"
  | "primary"
  | "success"
  | "error"
  | "info"
  | "warning"
  | undefined;

type VariantType = "text" | "outlined" | "contained";

export const equipmentListActionButton = (token?: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "Create",
    },
    {
      id: 2,
      icon: <QrCodeIcon />,
      caption: "QR코드생성",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentsQRCodes?token=${token}
      `,
    },
    {
      id: 3,
      icon: <WordIcon width="20px" height="20px" />,
      caption: "Word로저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentsToWord?token=${token}
      `,
    },
    {
      id: 4,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel로저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentsToExcel?token=${token}

      `,
    },
    {
      id: 5,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel양식받기",
      colors: "success",
      variant: "outlined",
      anchor: `/Downloads/Equipment/Sample/설비이력카드양식-샘플.xlsx`,
    },
  ];
};
export const createEquipmentActionButton = (param: number, token: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <WordIcon width="20px" height="20px" />,
      caption: "Word로 저장",
      colors: "primary",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToWord?token=${token}&id=${param}`,
    },
    {
      id: 2,
      icon: <PdfIcon width="20px" height="20px" />,
      caption: "PDF로 저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToPDF?token=${token}&id=${param}`,
    },
    {
      id: 3,
      icon: <GroupWorkIcon />,
      caption: "Work Order작성",
      colors: "success",
      variant: "outlined",
      link: `/WorkOrder/Create/${param}`,
    },
    {
      id: 4,
      icon: <QrCodeIcon />,
      caption: "QR Code 생성",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentQRCode?token=${token}&id=${param}`,
    },
    {
      id: 5,
      icon: <KeyboardIcon />,
      caption: "설비이력작성",
      colors: "success",
      variant: "outlined",
      link: `/WorkOrder/CreateManual/${param}`,
    },
  ];
};
export const adminCreateEquipmentActionButton = (
  param: number,
  token: string
): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <WordIcon width="20px" height="20px" />,
      caption: "Word로 저장",
      colors: "primary",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToWord?token=${token}&id=${param}`,
    },
    {
      id: 2,
      icon: <PdfIcon width="18px" height="18px" />,
      caption: "PDF로 저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToPDF?token=${token}&id=${param}`,
    },

    {
      id: 4,
      icon: <QrCodeIcon />,
      caption: "QR Code 생성",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentQRCode?token=${token}&id=${param}`,
    },
  ];
};
export const createControlActionButton = (param: number): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <AutoFixHighIcon />,
      caption: "편집",
      colors: "info",
      variant: "contained",
      link: `/Equipment/Edit/${param}`,
    },
    {
      id: 2,
      icon: <FormatListBulletedIcon />,
      caption: "목록으로",
      colors: "success",
      variant: "contained",
      link: -1,
    },
  ];
};
export const createControlSpeedDial = (param: number, token: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <AutoFixHighIcon />,
      caption: "편집",
      colors: "info",
      variant: "contained",
      link: `/Equipment/Edit/${param}`,
    },
    {
      id: 2,
      icon: <FormatListBulletedIcon />,
      caption: "목록으로",
      colors: "success",
      variant: "contained",
      link: "/Equipment",
    },
    {
      id: 3,
      icon: <WordIcon width="20px" height="20px" />,
      caption: "Word로 저장",
      colors: "primary",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToWord?token=${token}&id=${param}`,
    },
    {
      id: 4,
      icon: <PdfIcon width="18px" height="18px" />,
      caption: "PDF로 저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentToPDF?token=${token}&id=${param}`,
    },

    {
      id: 5,
      icon: <QrCodeIcon />,
      caption: "QR Code 생성",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportEquipmentQRCode?token=${token}&id=${param}`,
    },
    {
      id: 6,
      icon: <KeyboardIcon />,
      caption: "설비이력작성",
      colors: "success",
      variant: "outlined",
      link: `/WorkOrder/CreateManual/${param}`,
    },
  ];
};

export const curriculumListActionButton = (queryString?: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Education/CreateCurriculum",
    },
    {
      id: 2,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel로 저장",
      colors: "success",
      variant: "outlined",
      anchor: "/API/ExportCurriculumsToExcel?" + queryString,
    },
  ];
};
export const editExamActionButton = (execution?: any): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryBooksIcon />,
      caption: "문항추가",
      colors: "primary",
      variant: "contained",
      execution,
    },

    {
      id: 2,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel양식 받기",
      colors: "success",
      variant: "outlined",
      anchor: `/Downloads/Equipment/Sample/근로자교육-문제등록샘플.xlsx`,
    },
  ];
};
export const tutorActionButton = (queryString: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Education/CreateTutor",
    },
    {
      id: 2,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel로 저장",
      colors: "success",
      variant: "outlined",
      anchor: "/API/ExportTutorsToExcel?" + queryString,
    },
  ];
};
export const workOrderRecordActionButton = (token: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel로 저장",
      colors: "primary",
      variant: "outlined",
      anchor: `/API/ExportRecordsToExcel?token=${token}`,
    },
    {
      id: 2,
      icon: <PdfIcon width="18px" height="18px" />,
      caption: "PDF로 저장",
      colors: "success",
      variant: "outlined",
      anchor: `/API/ExportRecordsToPDF?token=${token}`,
    },
  ];
};
export const documentActionButton = (execution?: any): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      execution,
    },
  ];
};

export const changeRequestListActionButton = (queryString: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/WorkOrder/CreateChangeRequest",
    },
    {
      id: 2,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel로 저장",
      colors: "success",
      variant: "outlined",
      anchor: "/API/ExportChangeRequestsToExcel?" + queryString,
    },
  ];
};
export const userListActionButton = (execution: any): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Officer/Create",
    },
    {
      id: 2,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel 양식받기",
      colors: "success",
      variant: "outlined",
      link: "/Education/CreateTutor",
    },
    {
      id: 3,
      icon: <ExcelIcon width="20px" height="20px" />,
      caption: "Excel 불러오기",
      colors: "success",
      variant: "outlined",
      execution,
    },
  ];
};

export const dangerEvaluationListActionButton = (param?: number): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/DangerEvaluation/Create",
    },
    {
      id: 2,
      icon: <QrCodeIcon />,
      caption: "QR Code 생성",
      colors: "success",
      variant: "outlined",
      link: "",
    },
  ];
};
export const dangerEvaluationRevisionListActionButton = (
  queryString: string
): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Permission/Create",
    },
    // {
    //   id: 2,
    //   icon: <QrCodeIcon />,
    //   caption: "QR Code 생성",
    //   colors: "success",
    //   variant: "outlined",
    //   link: "",
    // },
    {
      id: 3,
      icon: "",
      caption: "summary report",
      colors: "secondary",
      variant: "contained",
      anchor: "/API/GetPermissionSummaryReport?" + queryString,
    },
  ];
};

export const evaluationMasterListActionButton = (queryString: string): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Permission/CreateMaster",
    },
    // {
    //   id: 2,
    //   icon: <QrCodeIcon />,
    //   caption: "QR Code 생성",
    //   colors: "success",
    //   variant: "outlined",
    //   link: "",
    // },
    {
      id: 3,
      icon: "",
      caption: "summary report",
      colors: "secondary",
      variant: "contained",
      anchor: "/API/GetPermissionSummaryReport?" + queryString,
    },
  ];
};

export const evaluationRevisionListActionButton = (id: string | undefined): ActionButtonData[] => {
  return [
    {
      id: 1,
      icon: <LibraryAddIcon />,
      caption: "새로추가",
      colors: "primary",
      variant: "outlined",
      link: "/Permission/Create/" + id,
    },
    // {
    //   id: 2,
    //   icon: <QrCodeIcon />,
    //   caption: "QR Code 생성",
    //   colors: "success",
    //   variant: "outlined",
    //   link: "",
    // },
    // {
    //   id: 3,
    //   icon: "",
    //   caption: "summary report",
    //   colors: "secondary",
    //   variant: "contained",
    //   anchor: "/API/GetPermissionSummaryReport?" + queryString,
    // },
  ];
};
